import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'
import { Link } from 'gatsby'

import { content } from './maintenance-message.content'
import classes from './maintenance-message.module.scss'
import MaintenanceSVG from '../../static/images/maintenance.svg'
import { SiteContainer } from '../shared'

const dateFormatter = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: false,
})

interface MaintenanceMessageProps {
  endAt?: Date | string
}

export const MaintenanceMessage: FC<MaintenanceMessageProps> = ({ endAt }) => (
  <SiteContainer>
    <div className={classes.container}>
      <img
        className={classes.image}
        src={MaintenanceSVG}
        alt={content.imageAlt}
        data-testid="maintenance-warning"
      />
      <Typography
        component="h1"
        variant="Kollektif/ExtraLarge"
        className={classes.title}
        dataTestId="maintenance-title"
      >
        {content.title}
      </Typography>
      <Typography
        variant="Kollektif/Small"
        className={classes.text}
        dataTestId="maintenance-message"
      >
        {content.message}
      </Typography>
      {endAt && (
        <Typography
          variant="Kollektif/Small"
          className={classes.text}
          dataTestId="maintenance-end-at"
        >
          {content.endAtPrefix} {dateFormatter.format(new Date(endAt))}
        </Typography>
      )}
      <Typography
        variant="Kollektif/Small"
        className={classes.text}
        dataTestId="maintenance-signoff"
      >
        {content.signoff}
      </Typography>
      <Link to={content.goToWebsiteHref} data-testid="go-to-website-link">
        {content.goToWebsiteLabel}
      </Link>
    </div>
  </SiteContainer>
)

export default MaintenanceMessage
